module.exports = __webpack_public_path__ + "static/flags/MB-aa23acd2bc5b6e194994e60dae96771c.gif";